module.exports = fox._r("images/wv-img-2.jpg", __webpack_public_path__ + "images/wv-img-2.jpg");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/wv-img-2.jpg
// module id = 988
// module chunks = 4